/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import {
  Modal,
  Button,
  Box,
  CircularProgress,
  TextField,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  InputAdornment
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { ValidateUOM } from '../../assets/validation';
import UomAction from '../../store/actions/UomAction';
// import { technologyAction } from "../../../redux/actions/technologyAction";

function UOMAdd({ openmodal, onCloseModal }) {
  /* Modal Style */

  const dispatch = useDispatch();

  return (
    <Modal
      className="cmn__form__modal"
      open={openmodal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box>
        <Formik
          initialValues={{
            name: '',
            short_name: ''
          }}
          // enableReinitialize
          validationSchema={ValidateUOM}
          onSubmit={(values, { setErrors, setSubmitting }) => {
            dispatch(UomAction.add(values, setErrors, setSubmitting, onCloseModal));
          }}
        >
          {({
            errors,
            touched,
            values,
            handleChange,
            handleBlur,
            handleSubmit,
            handleReset,
            isSubmitting,
            setFieldValue
          }) => (
            <form onSubmit={handleSubmit}>
              <Card>
                <CardHeader
                  title="Add UOM"
                  action={
                    <IconButton
                      aria-label="settings"
                      onClick={() => {
                        onCloseModal();
                      }}
                    >
                      <Close />
                    </IconButton>
                  }
                />
                <CardContent>
                  <TextField
                    id="name"
                    fullWidth
                    label="UOM Name"
                    name="name"
                    margin="normal"
                    placeholder="Enter UOM Name"
                    value={values.name}
                    onChange={handleChange}
                    onBlur={(e) => {
                      const val = (e.target.value || '').replace(/\s+/gi, ' ');
                      setFieldValue(e.target.name, val.trim());
                      handleBlur(e);
                    }}
                    // onBlur={handleBlur}
                    error={errors.name && touched.name}
                    helperText={errors.name && touched.name && errors.name}
                    required={false}
                    InputLabelProps={{ required: true }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            disabled
                            sx={{
                              bgcolor: 'secondary.main',
                              borderRadius: '5px',
                              '&.Mui-disabled': {
                                bgcolor: 'secondary.main'
                              },
                              '&:hover': {
                                borderColor: 'secondary.main',
                                borderWidth: '1px',
                                borderStyle: 'solid'
                              }
                            }}
                            // color="secondary"
                          >
                            <i className="icon-measure" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                  <TextField
                    id="short_name"
                    fullWidth
                    label="UOM Short Name"
                    name="short_name"
                    margin="normal"
                    placeholder="Enter UOM Short Name"
                    value={values.short_name}
                    onChange={handleChange}
                    onBlur={(e) => {
                      const val = (e.target.value || '').replace(/\s+/gi, '');
                      setFieldValue(e.target.name, val.trim());
                      handleBlur(e);
                    }}
                    error={errors.short_name && touched.short_name}
                    helperText={errors.short_name && touched.short_name && errors.short_name}
                    required={false}
                    InputLabelProps={{ required: true }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="start">
                          <IconButton
                            aria-label="toggle password visibility"
                            edge="end"
                            disabled
                            sx={{
                              bgcolor: 'secondary.main',
                              borderRadius: '5px',
                              '&.Mui-disabled': {
                                bgcolor: 'secondary.main'
                              },
                              '&:hover': {
                                borderColor: 'secondary.main',
                                borderWidth: '1px',
                                borderStyle: 'solid'
                              }
                            }}
                            // color="secondary"
                          >
                            <i className="icon-measure" />
                          </IconButton>
                        </InputAdornment>
                      )
                    }}
                  />
                </CardContent>
                <CardActions sx={{ justifyContent: 'center' }}>
                  <Button
                    type="submit"
                    className="save__btn"
                    variant="contained"
                    color="secondary"
                    // fullWidth
                    disabled={isSubmitting}
                    size="medium"
                  >
                    {isSubmitting ? <CircularProgress size={20} /> : 'Submit'}
                  </Button>
                  <Button
                    type="button"
                    className="cancel__btn"
                    variant="contained"
                    color="info"
                    size="medium"
                    onClick={() => {
                      handleReset();
                    }}
                  >
                    Clear
                  </Button>
                </CardActions>
              </Card>
            </form>
          )}
        </Formik>
      </Box>
    </Modal>
  );
}

UOMAdd.propTypes = {
  openmodal: PropTypes.string.isRequired,
  onCloseModal: PropTypes.func.isRequired
};

export default UOMAdd;
